searchModule.factory('productComboSearchService',
    ['$q', 'AppSettings', 'commonRESTCallService', 'QuoteSearchResult', 'searchUrlFactory','imSessionVarsService',
    function($q, AppSettings, commonRESTCallService, QuoteSearchResult, searchUrlFactory, imSessionVarsService) {
        var comboSearchApi = {};

        comboSearchApi.results = {
            list : []
        };

        comboSearchApi.clearResults = function() {
            comboSearchApi.results.list = [];
        };

        comboSearchApi.suppressMenuSearch = true;

        // these are in priority order
        comboSearchApi.searchResultTypes = { combo : 4,  alternateCombo: 3, menu : 2, dms : 1};

        comboSearchApi.search = function(parameters) {
            var promiseWrapper = $q.defer();

            var comboSearchUrl = searchUrlFactory.buildComboSearchUrl(parameters);
            var alternateSearchUrl = searchUrlFactory.buildAlternateComboSearchUrl(parameters);
            var menuSearchUrl = searchUrlFactory.buildMenuSearchUrl(parameters);

            var searchSuccess = []; // Entries are # results for each type, possibly 0. Negative means an error occured.
            searchSuccess[comboSearchApi.searchResultTypes.combo] = null;
            searchSuccess[comboSearchApi.searchResultTypes.alternateCombo] = null;
            searchSuccess[comboSearchApi.searchResultTypes.menu] = null;

            doSearchByType(comboSearchUrl, comboSearchApi.searchResultTypes.combo, promiseWrapper, searchSuccess);
            if(alternateSearchUrl)
                doSearchByType(alternateSearchUrl, comboSearchApi.searchResultTypes.alternateCombo, promiseWrapper, searchSuccess);
            else
                searchSuccess[comboSearchApi.searchResultTypes.alternateCombo] = 0; // no search, so no results. Not an error.

            if(!comboSearchApi.suppressMenuSearch) {
                doSearchByType(menuSearchUrl, comboSearchApi.searchResultTypes.menu, promiseWrapper, searchSuccess);
            } else {
                searchSuccess[comboSearchApi.searchResultTypes.menu] = 0; // no search, so no results. Not an error.
            }

            return promiseWrapper.promise;
        };

        function doSearchByType(url, type, promiseWrapper, searchSuccess) {
            commonRESTCallService.getFromServer(url)
                .success(function(responseData, status) {
                    var results = transformSearchResults(responseData);

                    if(results.length > 0) {
                        comboSearchApi.results.list = mergeSearchResults(comboSearchApi.results.list, results, type);
                        promiseWrapper.notify({type: type, searchStatus: searchSuccess});
                    }
                    searchSuccess[type] = results.length;
                }).error(function(responseData, status) {
                    searchSuccess[type] = -1;
                }).finally(function() {
                    checkSearchFinished(searchSuccess, promiseWrapper);
                });
        }

        function transformSearchResults(responseData) {
            var items = responseData.itemList || responseData;
            var results = items.map(function(element) {
                var quoteResult = new QuoteSearchResult();
                quoteResult.populateDataFromTLCAPI(element);

                return quoteResult;
            });

            results = _.groupBy(results, 'quoteSessionId');
            results = Object.keys(results).map(function(key) { return results[key][0] });

            return results;
        }

        function mergeSearchResults(existingItems, newItems, type) {
            if (!existingItems || existingItems.length == 0) {
                newItems.forEach(function(item) { item.searchType = type;});
                return newItems;
            }

            var filterNew = false,  // optimization, see below
                filterExisting = false;

            newItems.forEach(function(newItem) {
                newItem.searchType = type;

                var foundItem = _.find(existingItems, function (existingItem) {
                    return existingItem.areResultsEquivalent(newItem);
                });
                if (foundItem) {
                    if (foundItem.searchType < newItem.searchType) {
                        foundItem.__discard = true; // mark for discard
                        newItem.coalesce(foundItem); // but merge its properties to the new item
                        filterExisting = true;
                    }
                    else {
                        newItem.__discard = true; // mark for discard
                        foundItem.coalesce(newItem); // but merge its properties to the existing item
                        filterNew = true;
                    }
                }
            });

            // optimization: don't filter if we already know there is nothing to discard
            if (filterExisting) {
                existingItems = existingItems.filter(function (item) { return !item.__discard; });
            }

            // optimization: don't filter if we already know there is nothing to discard
            if (filterNew) {
                newItems = newItems.filter(function (item) { return !item.__discard;  });
            }

            return existingItems.concat(newItems);
        }

        function checkSearchFinished(searchSuccess, promiseWrapper) {
            if(!searchSuccess.some(function(element) { return element === null; })) {
                if (searchSuccess.some(function(item) { return item < 0})) {
                    promiseWrapper.reject("Search failed");  // An error occurred on one of the requests
                } else {
                    promiseWrapper.resolve(searchSuccess)
                }
            }
        }

        return comboSearchApi;
    }
]);